import { render, staticRenderFns } from "./ControleCliente.vue?vue&type=template&id=6e92e144&"
import script from "./ControleCliente.vue?vue&type=script&lang=js&"
export * from "./ControleCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports